import {
  ORGANIZATION_STRUCTURE_FETCHING,
  ORGANIZATION_STRUCTURE_SUCCESS,
  ORGANIZATION_STRUCTURE_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ORGANIZATION_STRUCTURE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ORGANIZATION_STRUCTURE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ORGANIZATION_STRUCTURE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
